import React, { useState } from "react";
import styles from "./contactForm.module.scss";
import { Paper } from "@mui/material";
import CustomInput from "../customInput/CustomInput";
import CustomRadio from "../customRadio/CustomRadio";

const formFields = [
  {
    label: "First Name*",
    inputKey: "fName",
    type: "text",
    textArea: false,
    placeholder: "Your first name",
    fullWidth: false,
  },
  {
    label: "Last Name*",
    inputKey: "lName",
    type: "text",
    textArea: false,
    placeholder: "Your last name",
    fullWidth: false,
  },
  {
    label: "Mobile Number*",
    inputKey: "mobileNumber",
    type: "text",
    textArea: false,
    placeholder: "Enter mobile number",
    fullWidth: true,
  },
  {
    label: "Email*",
    inputKey: "email",
    type: "email",
    textArea: false,
    placeholder: "Enter mail",
    fullWidth: true,
  },
  {
    label: "Write Message",
    inputKey: "message",
    type: "text",
    textArea: true,
    placeholder: "Write your message here",
    fullWidth: true,
  },
];

const radioData = [
  {
    label: "Mail",
    inputKey: "selectedOption",
    value: "mailContact",
  },
  {
    label: "Mobile Number",
    inputKey: "selectedOption",
    value: "mobileContact",
  },
];

const ContactForm = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const initialFormState = {
    fName: "",
    lName: "",
    mobileNumber: "",
    email: "",
    message: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  const handleContactMethod = (value) => {
    setSelectedOption(value);
    setErrors((prev) => ({ ...prev, contactMethod: "" }));
  };

  const handleChange = (key, enteredValue) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: enteredValue,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [key]: "",
    }));
  };

  const onSubmit = () => {
    const newErrors = {};

    const limitName = (key) =>
      key !== "message" && formData[key] && formData[key].length > 12;

    const limitNumber = (key) =>
      key !== "message" && formData[key] && formData[key].length > 10;

    if (!formData.fName.trim()) {
      newErrors.fName = "First name is required.";
    } else if (formData.fName.trim().length < 3) {
      newErrors.fName = "First name must be at least 3 characters.";
    } else if (limitName("fName")) {
      newErrors.fName = "First name cannot exceed 12 characters.";
    }

    if (!formData.lName.trim()) newErrors.lName = "Last name is required.";
    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile number is required.";
    } else if (formData.mobileNumber.length !== 10) {
      newErrors.mobileNumber = "Mobile number must be 10 digits.";
    }

    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formData.mobileNumber)) {
      newErrors.mobileNumber = "Mobile number must be exactly 10 digits.";
    }
    if (!selectedOption)
      newErrors.contactMethod = "Please select a contact method.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      contactMethod: selectedOption,
    }));

    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData(initialFormState);
      setSelectedOption(null);
      setErrors({});
    }, 10000);
  };

  return (
    <div className={styles.container}>
      <Paper classes={{ root: styles.wrapper }}>
        {!submitted ? (
          <form className={styles.formWrapper}>
            <div className={styles.row}>
              {formFields.slice(0, 2).map((item, index) => (
                <div key={index} className={styles.halfInput}>
                  <CustomInput
                    label={item.label}
                    inputKey={item.inputKey}
                    type={item.type}
                    value={formData[item.inputKey]}
                    onChange={handleChange}
                    placeholder={item.placeholder}
                    fullWidth={item.fullWidth}
                    textArea={item.textArea}
                  />
                  {errors[item.inputKey] && (
                    <p className={styles.errorText}>{errors[item.inputKey]}</p>
                  )}
                </div>
              ))}
            </div>
            {formFields.slice(2).map((item, index) => (
              <div key={index + 2}>
                <CustomInput
                  label={item.label}
                  inputKey={item.inputKey}
                  type={item.type}
                  value={formData[item.inputKey]}
                  onChange={handleChange}
                  placeholder={item.placeholder}
                  fullWidth={item.fullWidth}
                  textArea={item.textArea}
                />
                {errors[item.inputKey] && (
                  <p className={styles.errorText}>{errors[item.inputKey]}</p>
                )}
              </div>
            ))}

            <div className={styles.radioContainer}>
              <div className={styles.text}>
                How would like us to contact you?
              </div>
              <div className={styles.radioWrapper}>
                {radioData.map((item, index) => (
                  <CustomRadio
                    name={item.inputKey}
                    key={index + 1}
                    label={item.label}
                    value={item.value}
                    checked={selectedOption === item.value}
                    onChange={handleContactMethod}
                  />
                ))}
              </div>
              {errors.contactMethod && (
                <p className={styles.errorText}>{errors.contactMethod}</p>
              )}
            </div>

            <button type="button" className={styles.button} onClick={onSubmit}>
              Send Message
            </button>
          </form>
        ) : (
          <div className={styles.successWrapper}>
            <div className={styles.imgWrapper}>
              <img
                src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/CONTACT_US/contactUsDroneImage.png"
                alt="Drone"
              />
            </div>
            <div className={styles.textWrapper}>
              <h3 className={styles.heading}>We Will Contact You Shortly</h3>
              <p className={styles.text}>Your Message Has Been Received</p>
            </div>
          </div>
        )}
      </Paper>
    </div>
  );
};

export default ContactForm;
